import { render, staticRenderFns } from "./DevDocTable.vue?vue&type=template&id=3bae9f8c&"
import script from "./DevDocTable.vue?vue&type=script&lang=js&"
export * from "./DevDocTable.vue?vue&type=script&lang=js&"
import style0 from "./DevDocTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports